var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkdin = function SvgLinkdin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6448_50406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4153 0 16 3.58469 16 8C16 12.4153 12.4153 16 8 16C3.58469 16 0 12.4153 0 8C0 3.58469 3.58469 0 8 0ZM5.49884 12.496V6.24844H3.42184V12.496H5.49884ZM12.987 12.496V8.91328C12.987 6.99425 11.9624 6.10153 10.5961 6.10153C9.49434 6.10153 9.00084 6.70744 8.72453 7.133V6.24844H6.64806C6.67559 6.83459 6.64806 12.496 6.64806 12.496H8.7245V9.00691C8.7245 8.82016 8.73794 8.63347 8.79297 8.5C8.94281 8.12703 9.28475 7.74066 9.85844 7.74066C10.6095 7.74066 10.9104 8.31378 10.9104 9.15328V12.496H12.987ZM4.47437 3.23594C3.76375 3.23594 3.29947 3.70313 3.29947 4.31547C3.29947 4.91491 3.74963 5.39497 4.44688 5.39497H4.46028C5.1845 5.39497 5.63528 4.91491 5.63528 4.31547C5.62184 3.70313 5.18453 3.23594 4.47437 3.23594Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6448_50406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkdin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkdin.4b9de3e4.svg";
export { ForwardRef as ReactComponent };